/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_MixdownInputs */

const en_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown`)
};

const fr_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown`)
};

const de_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown`)
};

const it_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixaggio`)
};

const ru_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Миксдаун`)
};

const es_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mezcla`)
};

const zh_cn2_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混战`)
};

const ja_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミックスダウン`)
};

const hi_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बहुत चुप`)
};

const pt_pt2_audio_description_export_loudness_mixdown = /** @type {(inputs: Audio_Description_Export_Loudness_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixagem`)
};

/**
* | output |
* | --- |
* | "Mixdown" |
*
* @param {Audio_Description_Export_Loudness_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_mixdown = /** @type {((inputs?: Audio_Description_Export_Loudness_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_mixdown(inputs)
	if (locale === "de") return de_audio_description_export_loudness_mixdown(inputs)
	if (locale === "it") return it_audio_description_export_loudness_mixdown(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_mixdown(inputs)
	if (locale === "es") return es_audio_description_export_loudness_mixdown(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_mixdown(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_mixdown(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_mixdown(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_mixdown(inputs)
	return en_audio_description_export_loudness_mixdown(inputs)
});